import { useEffect, useState } from "react";
import { X, Cookie } from "lucide-react";
import { Link } from "react-router-dom";

const KEY = "dk_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const [manage, setManage] = useState(false);
  const [analytics, setAnalytics] = useState(true);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) setShow(true);
  }, []);

  const save = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ essential: true, analytics: choice, at: new Date().toISOString() }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[70] p-4 anim-in" data-testid="cookie-banner">
      <div className="dk-card max-w-3xl mx-auto p-5 sm:p-6" style={{ background: "var(--bg-raised)" }}>
        {!manage ? (
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <span className="grid place-items-center w-10 h-10 rounded-xl shrink-0" style={{ background: "var(--sage-tint)" }}><Cookie size={18} style={{ color: "var(--sage)" }} /></span>
            <p className="text-sm flex-1" style={{ color: "var(--text-muted)" }}>
              We use essential cookies to keep DecodeKid working, and optional ones to understand what helps parents most. Nothing about your child is ever tracked. See our <Link className="link" to="/cookies">Cookie Policy</Link>.
            </p>
            <div className="flex gap-2 shrink-0">
              <button className="btn btn-ghost" onClick={() => setManage(true)} data-testid="cookie-manage">Manage</button>
              <button className="btn btn-outline" onClick={() => save(false)} data-testid="cookie-reject">Reject</button>
              <button className="btn btn-primary" onClick={() => save(true)} data-testid="cookie-accept">Accept</button>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="font-serif text-[18px] font-medium">Cookie preferences</h3>
              <button className="btn btn-ghost px-2" onClick={() => setManage(false)}><X size={18} /></button>
            </div>
            <label className="flex items-start gap-3 opacity-70">
              <input type="checkbox" checked readOnly className="mt-1" />
              <span className="text-sm"><b>Essential</b> — required for login and security. Always on.</span>
            </label>
            <label className="flex items-start gap-3 cursor-pointer">
              <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} className="mt-1" data-testid="cookie-analytics-toggle" />
              <span className="text-sm"><b>Analytics</b> — anonymous usage to improve the tools. Never includes child data.</span>
            </label>
            <div className="flex justify-end gap-2">
              <button className="btn btn-outline" onClick={() => save(false)}>Reject all</button>
              <button className="btn btn-primary" onClick={() => save(analytics)} data-testid="cookie-save-prefs">Save preferences</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
